/**
 * Máquinas de estado del dominio.
 *
 * Viven en shared porque el backend las usa para rechazar transiciones
 * inválidas y el frontend para decidir qué botones habilita. Una sola
 * definición evita que la UI ofrezca acciones que la API va a rechazar.
 */
// --- Factura ----------------------------------------------------------------
export const ESTADOS_FACTURA = [
    /** Se puede editar libremente. Todavía no existe fiscalmente. */
    "BORRADOR",
    /** Se mandó a timbrar y no sabemos el resultado. Estado peligroso: ver TimbradoIntento. */
    "PENDIENTE_TIMBRE",
    /** Tiene UUID del SAT. Inmutable para siempre. */
    "TIMBRADA",
    /** El PAC rechazó el timbrado. Se puede corregir y reintentar. */
    "ERROR_TIMBRE",
    /** Se pidió la cancelación y falta la resolución del SAT. */
    "CANCELACION_SOLICITADA",
    /** Cancelada y confirmada por el SAT. */
    "CANCELADA",
];
export const TRANSICIONES_FACTURA = {
    BORRADOR: ["PENDIENTE_TIMBRE"],
    PENDIENTE_TIMBRE: ["TIMBRADA", "ERROR_TIMBRE"],
    ERROR_TIMBRE: ["PENDIENTE_TIMBRE", "BORRADOR"],
    TIMBRADA: ["CANCELACION_SOLICITADA"],
    // El SAT puede rechazar la cancelación (o el receptor no aceptarla),
    // en cuyo caso la factura regresa a TIMBRADA. No es un estado terminal.
    CANCELACION_SOLICITADA: ["CANCELADA", "TIMBRADA"],
    CANCELADA: [],
};
export const puedeTransicionar = (de, a) => TRANSICIONES_FACTURA[de].includes(a);
/** Estados en los que todavía se pueden tocar conceptos y montos. */
export const ESTADOS_FACTURA_EDITABLES = [
    "BORRADOR",
    "ERROR_TIMBRE",
];
export const esEditable = (estado) => ESTADOS_FACTURA_EDITABLES.includes(estado);
/** Ya existe ante el SAT: nunca se borra, a lo mucho se cancela. */
export const tieneEfectoFiscal = (estado) => estado === "TIMBRADA" ||
    estado === "CANCELACION_SOLICITADA" ||
    estado === "CANCELADA";
// --- Intento de timbrado ----------------------------------------------------
export const ESTADOS_INTENTO = [
    /** Se mandó la petición al PAC. */
    "ENVIADO",
    /** El PAC devolvió UUID. */
    "EXITO",
    /** El PAC devolvió un error explícito. Sabemos que NO se timbró. */
    "ERROR",
    /** Se cayó la red o venció el timeout. NO sabemos si se timbró: hay que reconciliar. */
    "INDETERMINADO",
    /** Se consultó al PAC y resultó que sí había timbrado. */
    "RECONCILIADO_TIMBRADO",
    /** Se consultó al PAC y confirmamos que no timbró. Se puede reintentar. */
    "RECONCILIADO_SIN_TIMBRE",
];
/**
 * Un intento en este estado bloquea cualquier reintento hasta que el job de
 * reconciliación lo resuelva. Reintentar a ciegas duplicaría un CFDI fiscal.
 */
export const intentoBloqueaReintento = (estado) => estado === "ENVIADO" || estado === "INDETERMINADO";
// --- Cotización -------------------------------------------------------------
export const ESTADOS_COTIZACION = [
    "BORRADOR",
    "ENVIADA",
    "ACEPTADA",
    "RECHAZADA",
    "VENCIDA",
    "CANCELADA",
];
export const TRANSICIONES_COTIZACION = {
    BORRADOR: ["ENVIADA", "CANCELADA"],
    ENVIADA: ["ACEPTADA", "RECHAZADA", "VENCIDA", "CANCELADA"],
    ACEPTADA: [],
    RECHAZADA: [],
    VENCIDA: ["ENVIADA"],
    CANCELADA: [],
};
// --- Proyecto ---------------------------------------------------------------
export const ESTADOS_PROYECTO = [
    "PROPUESTA",
    "ACTIVO",
    "EN_PAUSA",
    "COMPLETADO",
    "CANCELADO",
];
//# sourceMappingURL=estados.js.map